module.exports = __webpack_public_path__ + "img/9-9.61d7ef9c.jpeg";